import CarouselAbstr, { CarouselOptions } from '../carouselAbstr';

export default class MastheadCarousel extends CarouselAbstr {
	constructor(options: CarouselOptions) {
		super(options);
		this.init();
	}

	protected init(): void {
		const slidesColl = document.getElementsByClassName('masthead__slide');
		for (let i = 0; i < slidesColl.length; i++) {
			this.slides.push(slidesColl[i]);
		}

		this.buildIndicators();
		this.initAutoAdvance();
	}
}
